import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center justify-center text-center min-h-[60vh]">
      <p className="font-heading text-6xl md:text-8xl font-bold text-primary-700/70 mb-4 select-none">
        404
      </p>
      <h1 className="font-heading text-foreground-50 text-2xl md:text-3xl font-bold mb-3">
        页面不存在
      </h1>
      <p className="text-sm md:text-base text-foreground-400 font-label mb-2 max-w-lg">
        抱歉，你访问的页面可能已被移动或删除。
      </p>
      <p className="text-xs md:text-sm text-foreground-500 font-label mb-8 break-all">
        {location.pathname}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-600 hover:bg-primary-500 text-background-50 font-label text-sm transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-700 hover:border-accent-600 hover:text-accent-400 text-foreground-100 font-label text-sm transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-list-check-2" />
          浏览影片分类
        </Link>
      </div>
    </div>
  );
}